import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import user from "../../Assets/Image/admin/user.png";
import deletes from "../../Assets/Image/admin/delete.png";
import add from "../../Assets/Image/admin/add.png";
import Dialog from "../../Base-Component/Dialog/Dialog";
import noImage from "../../Assets/Image/admin/user.png";
import Eye from "../../Assets/Image/admin/eye.png";
import EyeSlash from "../../Assets/Image/admin/slasheye.png";
import back from "../../Assets/Image/admin/background2.png";
import {
  addSubAdmin,
  addUsers,
  deleteUsers,
  getModuleApi,
  getSubAdminList,
  listUserRole,
  updateSubAdmin,
  updateUsers,
} from "../../Services/ApiServices";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { IMG_URL } from "../../Services/Api";
import edit from "../../Assets/Image/admin/edit.png";
import cancel from "../../Assets/Image/admin/cancel.png";
import { useDebounce } from "use-debounce";
import FormSelect from "../../Base-Component/FormSelect/FormSelect";
import view from "../../Assets/Image/admin/view.png";
import { ChevronDown, ChevronUp, CircleX } from "lucide-react";
import { useFormik } from "formik";
import * as Yup from "yup";

function SubAdmin() {
  const navigate = useNavigate();

  const [isDragging, setIsDragging] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isAddUser, setIsAddUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [eyes, setEyes] = useState(0);
  const [eyess, setEyess] = useState(0);

  const [texts, setTexts] = useState("password");
  const [textss, setTextss] = useState("password");
  const [searchData, setSearchData] = useState("");
  const [totalPage, setTotalPage] = useState("");
  const [image, setImage] = useState("");
  const [img, setImg] = useState("");
  const [userId, setUserId] = useState({});
  const [isIndex, setIsIndex] = useState("");
  const [isRole, setIsRole] = useState("");
  const [subAdminDetails, setSubAdminDetails] = useState({});

  const [userData, setUserData] = useState([]);
  const [userRoleData, setUserRoleData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [search] = useDebounce(searchData, 500);

  // Yup Validation Schema - Dynamic based on isUpdate
  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      firstname: Yup.string()
        .required("First Name is required")
        .min(2, "First Name must be at least 2 characters"),
      lastname: Yup.string()
        .required("Last Name is required")
        .min(2, "Last Name must be at least 2 characters"),
      email: Yup.string()
        .required("Email is required")
        .email("Invalid email format"),
      password: isUpdate
        ? Yup.string().notRequired()
        : Yup.string()
          .required("Password is required")
          .matches(
            /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+=-]).{8,}$/,
            "Password must contain at least one Uppercase letter, one Special character and minimum 8 characters"
          ),
      new_password: isUpdate
        ? Yup.string().notRequired()
        : Yup.string()
          .required("Confirm Password is required")
          .oneOf([Yup.ref("password")], "Passwords must match"),
    });
  }, [isUpdate]);

  useEffect(() => {
    setSelectedOptions([1]);
  }, []);

  const handleUserList = () => {
    setLoader(true);
    let obj = {
      page: pageNo,
    };

    if (search) {
      obj.search = search;
    }

    getSubAdminList(obj)
      .then((res) => {
        const data = res.data.data;
        setUserData(data);
        setTotalPage(res.data.totalPages);
        setLoader(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setLoader(false);
      });
  };

  const handleSearchChange = (e) => {
    setSearchData(e.target.value);
    setPageNo(1);
  };

  const handleUserRoleList = () => {
    getModuleApi()
      .then((res) => {
        const data = res.data.data;
        setUserRoleData(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  useEffect(() => {
    handleUserList();
  }, [pageNo, search, isRole]);

  useEffect(() => {
    handleUserRoleList();
  }, []);

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const handleFile = (e) => {
    setImage(e.target.files[0]);
    let imageData = URL.createObjectURL(e.target.files[0]);
    setImg(imageData);
  };

  const handleEyes = () => {
    const flag = eyes == 0 ? 1 : 0;
    setEyes(flag);

    const text = texts == "password" ? "text" : "password";
    setTexts(text);
  };

  const handleEyess = () => {
    const flag = eyess == 0 ? 1 : 0;
    setEyess(flag);

    const text = textss == "password" ? "text" : "password";
    setTextss(text);
  };

  // Formik Setup
  const formik = useFormik({
    initialValues: {
      id: "",
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      new_password: "",
      profile_image: "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsLoading(true);
      if (!isUpdate) {
        // Add Sub Admin
        if (!image) {
          toast.error("Please select profile image.");
          setIsLoading(false);
          return;
        }
        if (selectedOptions.length === 0) {
          toast.error("Please select module");
          setIsLoading(false);
          return;
        }

        const formData = new FormData();
        formData.append("firstname", values.firstname);
        formData.append("lastname", values.lastname);
        formData.append("email", values.email);
        formData.append("password", values.password);
        formData.append("modules_id", selectedOptions.toString());
        if (image) {
          formData.append("profile_image", image);
        }

        addSubAdmin(formData)
          .then((res) => {
            toast.success(res.data.message);
            formik.resetForm();
            setIsAddUser(false);
            setImage("");
            setImg("");
            handleUserList();
            setIsLoading(false);
          })
          .catch((err) => {
            if (err.response.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err.response.data.message);
            }
            setIsLoading(false);
          });
      } else {
        // Update Sub Admin
        if (selectedOptions.length === 0) {
          toast.error("Please select module");
          setIsLoading(false);
          return;
        }

        const formData = new FormData();
        formData.append("user_id", values.id);
        formData.append("firstname", values.firstname);
        formData.append("lastname", values.lastname);
        formData.append("modules_id", selectedOptions.toString());
        if (subAdminDetails.email != values.email) {
          formData.append("email", values.email);
        }
        if (image) {
          formData.append("profile_image", image);
        }

        updateSubAdmin(formData)
          .then((res) => {
            toast.success(res.data.message);
            formik.resetForm();
            setIsAddUser(false);
            setImage("");
            setImg("");
            handleUserList();
            setIsLoading(false);
          })
          .catch((err) => {
            if (err.response.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err.response.data.message);
            }
            setIsLoading(false);
          });
      }
    },
  });

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      user_id: userId.id,
    };
    deleteUsers(obj)
      .then((res) => {
        toast.success(res.data.message);
        const data = [...userData];
        data.splice(isIndex, 1);
        setUserData(data);
        setModalOpens(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setIsLoading(false);
      });
  };

  const handleView = (data, index) => {
    setModalOpens(true);
    setUserId(data);
    setIsIndex(index);
    setIsLoading(false);
  };

  const handleAdd = () => {
    setIsAddUser(true);
    setIsLoading(false);
    setIsUpdate(false);
    setImage("");
    setImg("");
    setSelectedOptions([1]);
    setIsOpen(false);
    formik.resetForm({
      values: {
        id: "",
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        new_password: "",
        profile_image: "",
      },
    });
  };

  const handleEdit = (data) => {
    setIsUpdate(true);
    setSelectedOptions([]);
    setSubAdminDetails(data);
    setIsAddUser(true);
    setIsLoading(false);
    setImg("");
    setImage("");
    setIsOpen(false);
    formik.setValues({
      id: data.id || "",
      firstname: data.firstname || "",
      lastname: data.lastname || "",
      email: data.email || "",
      password: "",
      new_password: "",
      profile_image: data.profile_image || "",
    });
    for (let i = 0; i < data.userAllowedModule.length; i++) {
      const main = data.userAllowedModule[i].module_id;
      setSelectedOptions((pre) => [...pre, main]);
    }
  };

  const handleCheckboxChange = (option) => {
    if (option === 1) return;

    setSelectedOptions((prevSelected) =>
      prevSelected.includes(option)
        ? prevSelected.filter((item) => item !== option)
        : [...prevSelected, option]
    );
  };

  const toggleDropdown = () => {
    if (!isOpen) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  return (
    <>
      <div className="grid grid-cols-12 md:m-4 m-1 fontNew">
        <div className="col-span-12 duration-300 cursor-pointer">
          <div className="flex flex-wrap-reverse sm:justify-between justify-end items-start">
            <div className="flex xl:w-70 sm:w-52 w-full h-10 px-4 sm:mb-0 mb-3 rounded-[8px] bg-white items-center">
              <input
                type="text"
                required
                className="bg-transparent  sm:w-70 w-full border-none outline-none h-10 text-sm fontNew"
                placeholder="Search..."
                name="search_text"
                value={searchData}
                onChange={handleSearchChange}
              />
            </div>
            <div className="flex items-center">
              <button
                onClick={handleAdd}
                className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-5 rounded-lg whitespace-nowrap"
              >
                <img src={add} className="w-6 mr-2" alt="" />
                Add Sub Admin
              </button>
            </div>
          </div>
        </div>
        {loader ? (
          <div className="col-span-12 flex justify-center items-center  h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {userData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <div className="col-span-12">
                <div className="grid-cols-12 grid gap-5 my-7">
                  {userData.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="3xl:col-span-3 xl:col-span-4 lg:col-span-6 md:col-span-6 col-span-12 bg-white rounded-xl p-5"
                      >
                        <div className="flex items-start space-x-4">
                          <div className="xl:w-18 xl:h-18 lg:w-16 lg:h-16 w-14 h-14">
                            <img
                              src={
                                item.profile_image
                                  ? IMG_URL + item.profile_image
                                  : user
                              }
                              className="xl:min-w-18 xl:h-18 lg:min-w-16 lg:h-16 min-w-14 h-14 rounded-full object-cover"
                              alt=""
                            />
                          </div>
                          <div className="space-y-2">
                            <p className="text-base font-medium">
                              {item.firstname || "-"} {item.lastname || ""}
                            </p>
                            <p className="text-base font-medium">
                              {item.email || "-"}
                            </p>
                            <p className="text-base font-medium">
                              #{item.id || "-"}
                            </p>
                          </div>
                        </div>
                        <div className="w-full flex items-center justify-end space-x-4">
                          <div
                            onClick={() => {
                              setSubAdminDetails(item);
                              setIsDragging(true);
                            }}
                            className="cursor-pointer"
                          >
                            <img src={view} className="lg:w-9 w-8" alt="View" />
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={() => handleView(item, index)}
                          >
                            <img
                              src={deletes}
                              className="lg:w-9 w-8"
                              alt="Delete"
                            />
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={(e) => handleEdit(item)}
                          >
                            <img
                              src={edit}
                              className="lg:w-9 w-8"
                              alt="Delete"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                    <div className="flex items-center cursor-pointer">
                      <p
                        onClick={() => handlePageChange(pageNo - 1)}
                        disabled={pageNo === 1}
                      >
                        Previous
                      </p>
                      <div className="flex items-center mx-6">
                        {renderPaginationButtonss()}
                      </div>
                      <p
                        onClick={() => handlePageChange(pageNo + 1)}
                        disabled={pageNo === totalPage}
                      >
                        Next
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <Dialog
        key={isUpdate ? "update-form" : "add-form"}
        open={isAddUser}
        onClose={() => {
          setIsAddUser(false);
          formik.resetForm();
          setImage("");
          setImg("");
        }}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border border-white">
            <div className="p-4 md:max-h-[700px] max-h-[450px] overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">
                {isUpdate ? "Update" : "Add"} Sub Admin
              </h4>
              <form onSubmit={formik.handleSubmit} key={isUpdate ? "update" : "add"}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 flex items-center mx-2 my-3">
                    <div className="flex items-start">
                      <img
                        src={
                          img
                            ? img
                            : formik.values.profile_image
                              ? IMG_URL + formik.values.profile_image
                              : noImage
                        }
                        className="2xl:w-[106px] 2xl:h-[106px] w-[88px] h-[88px] rounded-full object-cover"
                        alt=""
                      />
                      {img ? (
                        <div
                          onClick={() => {
                            setImg("");
                            setImage("");
                          }}
                          className="bg-white rounded-full right-6 w-5 h-5 relative cursor-pointer"
                        >
                          <img src={cancel} className="w-5" alt="" />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="ms-5">
                      <h4 className="text-base font-semibold">Profile Image</h4>
                      <p className="text-xs my-2 text-[#9C9DA9]">
                        Png, JPG, up to 5 MB
                      </p>
                      <div className="mt-6">
                        <label
                          htmlFor="upload-photo"
                          className="bg-[#FBFBFB] text-[#5A5A5A] border-dashed border border-[#D9D9D9] py-3 px-5 rounded-lg text-sm font-normal cursor-pointer"
                        >
                          Upload image
                        </label>
                        <input
                          type="file"
                          onChange={(e) => handleFile(e)}
                          className="hidden"
                          id="upload-photo"
                          accept="image/*"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="md:col-span-6 col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">First Name</h4>
                    <input
                      type="text"
                      name="firstname"
                      {...formik.getFieldProps("firstname")}
                      className={`border px-4 py-3 rounded-md w-full outline-[#e1c595] ${formik.touched.firstname && formik.errors.firstname
                        ? "border-red-500"
                        : ""
                        }`}
                      placeholder="Enter"
                    />
                    {formik.touched.firstname && formik.errors.firstname && (
                      <p className="text-red-500 text-sm mt-1">
                        {formik.errors.firstname}
                      </p>
                    )}
                  </div>
                  <div className="md:col-span-6 col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">Last Name</h4>
                    <input
                      type="text"
                      name="lastname"
                      {...formik.getFieldProps("lastname")}
                      className={`border px-4 py-3 rounded-md w-full outline-[#e1c595] ${formik.touched.lastname && formik.errors.lastname
                        ? "border-red-500"
                        : ""
                        }`}
                      placeholder="Enter"
                    />
                    {formik.touched.lastname && formik.errors.lastname && (
                      <p className="text-red-500 text-sm mt-1">
                        {formik.errors.lastname}
                      </p>
                    )}
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Select Module</h4>
                    <div className="multi-select-dropdown bg-white rounded px-4 py-3 border w-full outline-2 outline-[#ead5fd]">
                      <div
                        className="flex justify-between cursor-pointer"
                        onClick={toggleDropdown}
                      >
                        <span>{"Select Multiple Module"}</span>
                        <button type="button">
                          {isOpen ? (
                            <ChevronUp className="text-[#000000]" />
                          ) : (
                            <ChevronDown className="text-[#000000]" />
                          )}
                        </button>
                      </div>

                      {isOpen && (
                        <div className="dropdown-menu w-full rounded-lg">
                          {userRoleData.map((item, index) => (
                            <label
                              key={index}
                              className="flex items-center space-x-2"
                            >
                              <input
                                type="checkbox"
                                className="absolute right-0 setOptionCheckbox"
                                checked={selectedOptions.includes(item.id)}
                                onChange={() => handleCheckboxChange(item.id)}
                                disabled={item.id === 1}
                              />
                              {item.module_name}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">Email</h4>
                    <input
                      type="text"
                      name="email"
                      {...formik.getFieldProps("email")}
                      className={`border px-4 py-3 rounded-md w-full outline-[#e1c595] ${formik.touched.email && formik.errors.email
                        ? "border-red-500"
                        : ""
                        }`}
                      placeholder="Enter"
                    />
                    {formik.touched.email && formik.errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {formik.errors.email}
                      </p>
                    )}
                  </div>
                  {isUpdate ? (
                    ""
                  ) : (
                    <>
                      <div className="col-span-12 md:mx-2 mx-0 my-3">
                        <h4 className="text-sm font-medium mb-3">Password</h4>
                        <div className="flex items-center">
                          <input
                            type={texts}
                            name="password"
                            {...formik.getFieldProps("password")}
                            className={`bg-transparent ps-4 pe-12 rounded-md border w-full outline-[#e1c595] h-[54px] text-base ${formik.touched.password && formik.errors.password
                              ? "border-red-500"
                              : ""
                              }`}
                            placeholder="Password"
                          />
                          {eyes == 0 ? (
                            <img
                              src={EyeSlash}
                              onClick={handleEyes}
                              className="p-2 w-10 h-10 -ms-12 cursor-pointer"
                              alt=""
                            />
                          ) : (
                            <img
                              src={Eye}
                              onClick={handleEyes}
                              className="p-2 w-10 h-8 -ms-12 cursor-pointer"
                              alt=""
                            />
                          )}
                        </div>
                        {formik.touched.password && formik.errors.password && (
                          <p className="text-red-500 text-sm mt-2">
                            {formik.errors.password}
                          </p>
                        )}
                      </div>
                      <div className="col-span-12 md:mx-2 mx-0 my-3">
                        <h4 className="text-sm font-medium mb-3">
                          Confirm Password
                        </h4>
                        <div className="flex items-center">
                          <input
                            type={textss}
                            name="new_password"
                            {...formik.getFieldProps("new_password")}
                            className={`bg-transparent ps-4 pe-12 rounded-md border w-full outline-[#e1c595] h-[54px] text-base ${formik.touched.new_password &&
                              formik.errors.new_password
                              ? "border-red-500"
                              : ""
                              }`}
                            placeholder="Confirm Password"
                          />
                          {eyess == 0 ? (
                            <img
                              src={EyeSlash}
                              onClick={handleEyess}
                              className="p-2 w-10 h-10 -ms-12 cursor-pointer"
                              alt=""
                            />
                          ) : (
                            <img
                              src={Eye}
                              onClick={handleEyess}
                              className="p-2 w-10 h-8 -ms-12 cursor-pointer"
                              alt=""
                            />
                          )}
                        </div>
                        {formik.touched.new_password &&
                          formik.errors.new_password && (
                            <p className="text-red-500 text-sm mt-2">
                              {formik.errors.new_password}
                            </p>
                          )}
                      </div>
                    </>
                  )}
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddUser(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-[#00987C] text-white h-[45px] w-30 rounded-lg"
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      `${isUpdate ? "Update" : "Add"}`
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => setModalOpens(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border border-white">
            <div>
              <img src={back} className="w-auto relative" alt="" />
              <div className="flex justify-center">
                <img
                  src={
                    userId.profile_image
                      ? IMG_URL + userId.profile_image
                      : noImage
                  }
                  className="object-cover absolute sm:w-24 sm:h-24 w-14 h-14 lg:-mt-36 md:-mt-30 sm:-mt-36 -mt-24 rounded-full border "
                  alt=""
                />
              </div>
            </div>
            <div className="flex justify-center text-center my-4 sm:px-16 px-5 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete Sub Admin?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure want to delete {userId.firstname || ""}{" "}
                  {userId.lastname || ""} from the sub admin?
                </p>
                <div className="flex items-center justify-center mt-16 mb-10">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setModalOpens(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDragging} onClose={() => setIsDragging(false)} size="md">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border border-white">
            <div className="max-h-[500px] overflow-auto">
              <div className="flex justify-between border-b p-5">
                <h4 className="text-lg font-medium">Sub Admin Details</h4>
                <CircleX
                  color="gray"
                  size={28}
                  onClick={() => setIsDragging(false)}
                  className="cursor-pointer"
                />
              </div>
              <div className="p-5">
                <div className="text-center">
                  <div className="flex justify-center my-3">
                    <img
                      src={
                        subAdminDetails.profile_image
                          ? IMG_URL + subAdminDetails.profile_image
                          : user
                      }
                      className="sm:w-34 sm:h-34 w-28 h-28 rounded-full object-cover"
                      alt=""
                    />
                  </div>
                  <p className="text-lg font-medium">
                    {subAdminDetails.firstname || "-"}{" "}
                    {subAdminDetails.lastname || ""}
                  </p>
                </div>
                <div className="space-y-4 mt-4">
                  <p className="text-base">
                    User Id :{" "}
                    <span className="font-medium">
                      #{subAdminDetails.id || "-"}
                    </span>
                  </p>
                  <p className="text-base">
                    Email :{" "}
                    <span className="font-medium">
                      {subAdminDetails.email || "-"}
                    </span>
                  </p>
                  <div className="flex">
                    <p className="text-base">Admin Module : </p>
                    <div className="ml-2">
                      {subAdminDetails?.userAllowedModule?.map(
                        (item, index) => {
                          return (
                            <p key={index} className="font-medium">
                              {item.modules.module_name || ""}
                            </p>
                          );
                        }
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </>
  );
}

export default SubAdmin;
